$(function() {
    var pagetop = $('#page_top');
    pagetop.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {  //100pxスクロールしたら表示
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
    pagetop.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 1500); //0.5秒かけてトップへ移動
        return false;
    });
});

$(function(){
  $('a[href^="#"]').click(function(){
    var time = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" ? 'html' : href);
    var distance = target.offset().top;
    $("html, body").animate({scrollTop:distance}, time, "swing");
    return false;
  });
});

$(function () {

	$('.menu-button').click(function () {
		$(this).toggleClass('active');
		$('.menu-bg').fadeToggle();
		$('nav').toggleClass('open');
	})
	$('.menu-bg').click(function () {
		$(this).fadeOut();
		$('.menu-button').removeClass('active');
		$('nav').removeClass('open');
	});
    $('.sp-nav a[href]').click(function () {
		$(this).removeClass('active');
		$('.menu-bg').fadeToggle();
        $('.menu-button').removeClass('active');
		$('nav').removeClass('open');
	})
});
